<template>
  <div :class="showButtons ? 'container-public-buttons' : ''">
    <public-buttons
      v-if="showButtons"
      :info="publicInfo.info"
      :image="
        publicInfo.identifiedItemImage
          ? publicInfo.identifiedItemImage
          : publicInfo.info.image
      "
    ></public-buttons>
    <public-brand
      v-if="publicInfo"
      :name="publicInfo.info.name"
      :image="
        publicInfo.identifiedItemImage
          ? publicInfo.identifiedItemImage
          : publicInfo.info.image
      "
      :logo="publicInfo.info.logo"
      :full-size="true"
      :avatar="publicInfo.info.avatar"
      :short-description="publicInfo.info.shortDescription"
      :item-id="publicInfo.identifiedItemId"
      :friendly-name="publicInfo.identifiedItemName"
      :imageNotStretched="publicInfo.identifiedItemNotStretchedImage"
    ></public-brand>
    <public-status
      v-if="publicInfo && publicInfo.result"
      :item-id="publicInfo.identifiedItemId"
      :organization-name="publicInfo.organizationName"
      :batch-id="publicInfo.identifiedBatchId"
      :result="publicInfo.result"
      :is-proprietary-task="publicInfo.result.proprietaryTask"
      :interaction-id="publicInfo.interactionId"
    ></public-status>
    <div v-if="displayOrderList">
      <div v-for="(displayOrder, index) in displayOrderList" :key="index">
        <public-support
          v-if="displayOrder.startsWith('support-') && getMiscellaneous"
          class="public-support"
          :item="
            getMiscellaneous.find(
              (support) => `support-${support.id}` === displayOrder,
            )
          "
        ></public-support>
        <public-attributes
          v-else-if="
            displayOrder === 'attributes' &&
            publicInfo.info.attributes &&
            publicInfo.info.attributes.length
          "
          :items="publicInfo.info.attributes"
          :attributes-header="publicInfo.info.publicAttributesHeader"
        ></public-attributes>
        <public-services
          v-else-if="displayOrder === 'services' && publicInfo.services"
          :items="publicInfo.services"
          :history="publicInfo.history"
        ></public-services>
        <public-attachments
          v-else-if="
            displayOrder === 'documents' &&
            getPublicAttachmentsAndDocuments &&
            getPublicAttachmentsAndDocuments.length
          "
          :items="getPublicAttachmentsAndDocuments"
        ></public-attachments>
        <public-gallery
          v-else-if="displayOrder === 'gallery' && publicInfo.info.gallery"
          :items="publicInfo.info.gallery"
        ></public-gallery>
        <public-certifications
          v-else-if="
            displayOrder === 'certifications' && publicInfo.info.certifications
          "
          :items="publicInfo.info.certifications"
        ></public-certifications>
        <public-video
          v-else-if="displayOrder === 'video' && getVideos"
          :items="getVideos"
        ></public-video>
        <div v-else-if="displayOrder === 'supportProfile'">
          <div v-if="getSupportProfiles">
            <public-support
              v-for="(supportProfile, index) in getSupportProfiles"
              :key="index"
              class="public-support"
              :item="supportProfile"
            ></public-support>
          </div>

          <public-support-profile
            v-if="publicInfo.identifiedItemSupportProfileAccount"
            :item="publicInfo.identifiedItemSupportProfileAccount"
          ></public-support-profile>
        </div>
        <public-long-description
          v-else-if="
            displayOrder === 'longDescription' &&
            publicInfo.info.longDescription
          "
          :item="publicInfo.info.longDescription"
        ></public-long-description>

        <public-interactions
          v-else-if="
            displayOrder === 'history' &&
            publicInfo.info.isEnabledDisplayInteractions
          "
          :items="getPublicInteractions"
          :title="
            publicInfo.info ? publicInfo.info.publicInteractionsHeader : null
          "
          :description="
            publicInfo.info
              ? publicInfo.info.publicInteractionsDescription
              : null
          "
          :displayTemplate="
            publicInfo.info ? publicInfo.info.publicInteractionsTemplate : null
          "
          :image="
            publicInfo.info ? publicInfo.info.publicInteractionsImage : null
          "
          :valueChain="publicInfo.valueChain"
          :historyEventGalleryData="historyEventGalleryData"
        ></public-interactions>
      </div>

      <rfider-pocily
        v-if="publicInfo"
        :entityName="publicInfo.organizationName"
        :urlPrivacyPolicy="publicInfo.info && publicInfo.info.urlPrivacyPolicy"
      ></rfider-pocily>
    </div>
  </div>
</template>

<script>
import PublicBrand from '@/components/public/publicBrand.vue';
import PublicCertifications from '@/components/public/publicCertifications.vue';
import PublicGallery from '@/components/public/publicGallery.vue';
import PublicLongDescription from '@/components/public/publicLongDescription.vue';
import PublicVideo from '@/components/public/publicVideo.vue';
import PublicInteractions from '@/components/public/publicInteractions.vue';
import PublicButtons from '@/components/public/publicButtons.vue';
import PublicAttachments from '@/components/public/publicAttachments.vue';
import PublicAttributes from '@/components/public/publicAttributes.vue';
import PublicServices from '@/components/public/publicServices.vue';
import RfiderPocily from '../../components/shared/rfiderPolicy.vue';
import PublicStatus from '@/components/public/publicStatus.vue';
import PublicSupport from '@/components/public/publicSupport.vue';
import PublicSupportProfile from '@/components/public/publicSupportProfile.vue';
import $ from 'jquery-slim';

export default {
  components: {
    PublicBrand,
    PublicCertifications,
    PublicGallery,
    PublicLongDescription,
    PublicVideo,
    PublicInteractions,
    PublicButtons,
    PublicAttachments,
    PublicAttributes,
    PublicServices,
    RfiderPocily,
    PublicStatus,
    PublicSupport,
    PublicSupportProfile,
  },
  props: {
    publicInfo: {
      type: Object,
      required: true,
    },
    displayButtons: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      codeInjections: [],
    };
  },
  provide() {
    return {
      registerCodeInjection: (id, content) => {
        this.codeInjections.push({ id: id, content: content });
      },
    };
  },
  watch: {
    codeInjections(newVal) {
      if (newVal.length) {
        newVal.forEach((ci) => {
          try {
            let parent = ci.id ? $(`#${ci.id}`) : document.body;
            let code = String(ci.content);

            if (ci.id) {
              code = code.replace(
                /<script\b[^>]*>([\s\S]*?)<\/script>/gi,
                "<script>(function(containerID){$1})('" +
                  ci.id +
                  "');</scr" +
                  'ipt>',
              );
            }

            $(code).appendTo(parent);
          } catch (err) {
            console.log(err);
          }
        });

        // need to re trigger load event in case that the injected code listens to it (eg: intercom)
        var load_event = document.createEvent('Event');
        load_event.initEvent('load', false, false);
        window.dispatchEvent(load_event);
      }
    },
  },
  mounted() {
    if (document && this.publicInfo) {
      document.rfiderCodeInjectionVars = {
        rfider_date_time: new Date().toISOString(),
        ...(this.publicInfo.info &&
          this.publicInfo.info.name && {
            rfider_thing_name: this.publicInfo.info.name,
          }),
        ...(this.publicInfo.identifiedItemId && {
          rfider_RFUID: this.publicInfo.identifiedItemId,
        }),
        ...(this.publicInfo.identifiedItemName && {
          rfider_item_name: this.publicInfo.identifiedItemName,
        }),
      };

      if (this.publicInfo.info.codeInjection) {
        this.codeInjections.push({
          id: null,
          content: this.publicInfo.info.codeInjection,
        });
      }
    }
  },
  computed: {
    getMiscellaneous() {
      let ret = null;
      try {
        const c = this.publicInfo.components.find((c) => c.name === 'support');
        ret = c.value.filter((sp) => {
          return sp.subType === null;
        });
      } catch (err) {
        ret = null;
      }
      return ret && ret.length ? ret : null;
    },
    getVideos() {
      let ret = null;
      try {
        const c = this.publicInfo.components.find((c) => c.name === 'video');
        if (c.value.length) {
          ret = c.value;
        }
      } catch (err) {
        ret = null;
      }
      return ret;
    },
    getSupportProfiles() {
      let ret = null;
      try {
        const c = this.publicInfo.components.find((c) => c.name === 'support');
        ret = c.value.filter((sp) => {
          return sp.subType === 'supportProfile';
        });
      } catch (err) {
        ret = null;
      }
      return ret && ret.length ? ret : null;
    },
    showButtons() {
      const display =
        this.displayButtons &&
        this.publicInfo &&
        this.publicInfo.info &&
        (this.publicInfo.info.urlProductInfo ||
          this.publicInfo.info.urlShopping ||
          this.publicInfo.info.urlLearnMore);
      return display;
    },
    historyEventGalleryData() {
      return {
        show: !!this.publicInfo.info.isEnabledPublicHistoryEventGallery,
        interactions: this.publicInfo.interactions,
        title: this.publicInfo.info.publicHistoryEventGalleryTitle,
        pagePosition:
          this.publicInfo.info.publicHistoryEventGalleryPagePosition,
      };
    },
    getPublicAttachmentsAndDocuments() {
      return this.getDocuments()
        .concat(this.publicInfo.attachments)
        .filter((i) => !!i);
    },
    displayOrderList() {
      let supportIdsToRemove = this.getDocuments().map(
        (doc) => `support-${doc.id}`,
      );
      if (this.getSupportProfiles) {
        supportIdsToRemove = supportIdsToRemove.concat(
          this.getSupportProfiles.map((sp) => `support-${sp.id}`),
        );
      }
      const displayOrderList =
        this.publicInfo &&
        this.publicInfo.info &&
        this.publicInfo.info.displayOrder
          ? this.publicInfo.info.displayOrder.filter(
              (order) => !supportIdsToRemove.includes(order),
            )
          : null;
      return displayOrderList;
    },
    getPublicInteractions() {
      return this.publicInfo && this.publicInfo.interactions
        ? (
            this.publicInfo.interactions.filter(
              (interaction) => !interaction.isPrivate,
            ) || []
          ).sort(
            (a, b) =>
              new Date(b.replacedDate || b.createdAt) -
              new Date(a.replacedDate || a.createdAt),
          )
        : [];
    },
  },
  methods: {
    getDocuments() {
      let publicDocuments = null;
      try {
        const c = this.publicInfo.components.find((c) => c.name === 'support');
        publicDocuments = Array.isArray(c.value)
          ? c.value.filter((sp) => sp.subType === 'document')
          : [];
      } catch (err) {
        publicDocuments = null;
      }
      publicDocuments = publicDocuments.map((pDoc) => {
        return {
          id: pDoc.id,
          file: pDoc.image,
          name: pDoc.name,
        };
      });
      return publicDocuments;
    },
  },
};
</script>

<style lang="scss" scoped>
.public-services,
.public-gallery,
.public-video,
.public-certification,
.public-attachments,
.public-attributes,
.public-long-desc,
::v-deep .public-event-history-gallery,
::v-deep .public-interactions,
.public-status,
.public-support,
.public-support-profile {
  margin: 0 24px;
  margin-top: 25px;
}

.container-public-buttons {
  padding-bottom: 130px;
}
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';
</style>
